import type { AdapterFormats } from "@mui/x-date-pickers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import { useMemo } from "react";
import type { FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { FormComponentProps } from "./FormComponentProps";

interface FormDatePickerProps<TFieldValues extends FieldValues = FieldValues> extends FormComponentProps<TFieldValues> {
  readonly fullWidth?: boolean;
  readonly minDate?: Dayjs;
  readonly readonly?: boolean;
}

const dateFormats: Partial<AdapterFormats> = { keyboardDate: "DD.MM.YYYY" };

function FormDatePicker<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  fullWidth,
  minDate,
  readonly,
}: FormDatePickerProps<TFieldValues>) {
  const slotProps = useMemo(
    () =>
      ({
        textField: {
          "aria-label": label,
          role: "datePicker",
          fullWidth,
        },
      }) as const,
    [fullWidth, label],
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl" dateFormats={dateFormats}>
            <DatePicker
              readOnly={readonly}
              onChange={onChange}
              value={value}
              label={label}
              slotProps={slotProps}
              minDate={minDate}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
}

export default FormDatePicker;
